/* eslint-disable camelcase */
import { postRequest } from '../../../helpers/request';

export default {
  state: () => ({
    operationsForContract: [],
  }),

  mutations: {
    setOperationsForContract(state, operations) {
      state.operationsForContract = operations;
    },
  },

  actions: {
    async fetchOperationsForContract({ commit }, contractId) {
      const { results } = await postRequest(
        '/farm_profile/api/get_contract_operations/',
        { contract_id: contractId },
      );
      commit('setOperationsForContract', results || []);
      return results || [];
    },

    async createContractOperation({ dispatch }, {
      contract_id,
      operation_type,
      number_of_contracts,
      operation_date,
      price,
      outcome,
      rolled_to_month,
      rolled_to_price,
      comments,
    }) {
      const payload = {
        contract: contract_id,
        operation_type,
        number_of_contracts,
        operation_date,
        price,
        outcome,
        rolled_to_month,
        rolled_to_price,
        comments,
      };
      const newOperation = await postRequest(
        '/farm_profile/api/create_contract_operation/',
        payload,
      );
      await dispatch('fetchOperationsForContract', contract_id);
      return newOperation;
    },

    async updateContractOperation({ dispatch }, {
      id,
      contract_id,
      to_update,
    }) {
      const updated = await postRequest(
        '/farm_profile/api/update_contract_operation/',
        { id, to_update },
      );
      await dispatch('fetchOperationsForContract', contract_id);
      return updated;
    },

    async deleteContractOperation({ dispatch }, { id, contract_id }) {
      await postRequest('/farm_profile/api/delete_contract_operation/', { id });
      await dispatch('fetchOperationsForContract', contract_id);
    },
  },

  namespaced: true,
};
